import React, { useEffect } from 'react';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import useDelete from '../customHooks/useDelete';

const canAccessCustomerAction = (permission, action) =>
  permission?.Customers?.includes(action) ||
  permission?.Customer?.includes(action);

const getInitials = (name = '') => {
  const parts = name.trim().split(/\s+/).filter(Boolean).slice(0, 2);
  if (parts.length === 0) {
    return 'CU';
  }
  return parts.map((part) => part[0]).join('').toUpperCase();
};

const CustomerCard = ({ data, alldata, deleted, permission }) => {
  const { id, name, email, phone, profile_image, is_active } = data;
  const [resDelete, apiMethodDelete] = useDelete();

  const handleDelete = () => {
    swal({
      title: 'Are you sure?',
      text: 'Are you sure that you want to delete?',
      buttons: true,
      icon: 'warning',
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        apiMethodDelete('customers/' + id);
      }
    });
  };

  useEffect(() => {
    if (resDelete.data) {
      const { message, status } = resDelete.data;
      if (status === 'false' || status === false) {
        toast.error(message);
        return;
      }

      deleted(alldata.filter((item) => item.id !== id));
      toast.success(message ?? 'Customer deleted successfully');
    }
  }, [alldata, deleted, id, resDelete.data]);

  useEffect(() => {
    if (resDelete.error) {
      toast.error(resDelete?.error?.response?.data?.message ?? 'Failed to delete customer');
    }
  }, [resDelete.error]);

  return (
    <div className='BlogsCard group relative overflow-hidden rounded-[1.5rem] border border-[#D4DEF1] bg-white shadow-custom transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_35px_rgba(18,38,63,0.10)]'>
      {canAccessCustomerAction(permission, 'Customer Delete') && (
        <div
          className='closeButton cursor-pointer absolute bg-[#FFCEDA] w-[2rem] h-[2rem] p-[.6rem] top-[.7rem] right-[.7rem] grid place-items-center rounded-[.7rem] z-10'
          onClick={handleDelete}
        >
          <svg className='w-full h-full' width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M15.8612 1.34766L0.951172 16.2567M15.8612 16.2577L0.951172 1.34863' stroke='#ED2656' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
          </svg>
        </div>
      )}

      <Link className='BlogsCardMain flex flex-col gap-4 p-4 lg:flex-row lg:items-center' to={'/customers/edit/' + id}>
        <div className='BlogsCard__left flex items-center justify-center lg:w-[12rem] lg:flex-none'>
          {profile_image ? (
            <img src={profile_image} className='h-[11rem] w-full rounded-[1.25rem] object-cover lg:h-[8rem]' alt={name || 'customer'} />
          ) : (
            <div className='flex h-[11rem] w-full items-center justify-center rounded-[1.25rem] border border-dashed border-[#D4DEF1] bg-[#EFF4FD] text-xl font-MluvkaBold text-[#7D8CA7] lg:h-[8rem]'>
              {getInitials(name)}
            </div>
          )}
        </div>

        <div className='BlogsCard__leftRight min-w-0 flex-1 lg:pr-4'>
          <div className='flex items-start justify-between gap-3 mb-2'>
            <div className='max-h-[3.1rem] overflow-hidden text-[1.1rem] capitalize font-MluvkaLight leading-[1.2] text-[#101828] lg:text-[1.25rem]'>{name}</div>
            <span className={'text-[.7rem] px-3 py-1 rounded-full whitespace-nowrap ' + (String(is_active) === '1' ? 'bg-[#E8F7EE] text-[#12804D]' : 'bg-[#FDEBEC] text-[#C81E3A]')}>
              {String(is_active) === '1' ? 'Active' : 'Inactive'}
            </span>
          </div>
          <div className='text-[#475467] text-[.85rem] leading-[1.6] mb-2 break-all'>Email: {email || '-'}</div>
          <div className='text-[#475467] text-[.85rem] leading-[1.6] mb-2'>Phone: {phone || '-'}</div>
          <div className='text-[#7D8CA7] text-[.75rem] leading-[1.5]'>Customer ID: {id}</div>
        </div>
        <div className="flex flex-row items-center justify-between gap-3 border-t border-[#EEF2F7] pt-4 lg:w-[10rem] lg:flex-col lg:items-end lg:justify-center lg:border-t-0 lg:pt-0 status-button">
          <span className="text-sm font-MluvkaBold text-[#0F172A]">Open</span>
          <span className="rounded-full bg-[#EFF4FD] px-4 py-2 text-sm font-MluvkaBold text-primary transition-colors group-hover:bg-primary group-hover:text-white">
            Edit
          </span>
        </div>
      </Link>
    </div>
  );
};

export default CustomerCard;
